<dxp-link *ngFor="let action of params.linkData.actions; let i = index" state="enabled" open-in-new-tab="false"
    type="dxp-btn-custom-link" [text]="action.DisplayText" aria-label="Click on the link to perform action"
    (click)="this.triggerAction(i, this.params.data)" class="link-btn">
</dxp-link>